import { render, staticRenderFns } from "./GBoothItemForm.vue?vue&type=template&id=746b8d5f&scoped=true&"
import script from "./GBoothItemForm.vue?vue&type=script&lang=ts&"
export * from "./GBoothItemForm.vue?vue&type=script&lang=ts&"
import style0 from "./GBoothItemForm.vue?vue&type=style&index=0&id=746b8d5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746b8d5f",
  null
  
)

export default component.exports